import initialState from "../../store/initialState";

const subscriptionInitialState = {
	...initialState,
	subscriptionData: {},
	statusSubscriptionData: {}
};

export default subscriptionInitialState;
